import { Controller } from "@hotwired/stimulus"

// Blendet ein verdecktes Feld (type="password") ein und wieder aus. Die Button-Texte kommen aus showValue/hideValue.
export default class extends Controller {
  static targets = ["field", "button"]
  static values = { show: String, hide: String }

  toggle() {
    const hidden = this.fieldTarget.type === "password"
    this.fieldTarget.type = hidden ? "text" : "password"
    this.buttonTarget.textContent = hidden ? this.hideValue : this.showValue
  }
}
